import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModelLocatorService } from 'src/app/services/config/model-locator.service';
import { MenuService } from 'src/app/services/menu-service/menu.service';
import { MessageService } from 'src/app/services/message-service/message.service';

@Component({
    selector: 'app-mm-menu-header',
    templateUrl: './mm-menu-header.component.html',
    styleUrls: ['./mm-menu-header.component.scss'],
})
export class MmMenuHeaderComponent implements OnInit {

    public menuInteracao: boolean = false;
    public menuLoja: boolean = false;
    public menuSuperacao: boolean = false;
    public menuInformacao: boolean = false;
    public menuPlanos: boolean = false;

    menuHeader: any = [];

    constructor(
        private router: Router,
        public modelLocator: ModelLocatorService,
        private messageServive: MessageService,
        private http: HttpClient,
        private menuService: MenuService
    ) {
    }

    async ngOnInit() {
        this.menuHeader = [
            { key: 'interacao', label: 'INTERAÇÃO', route: '/home', disabled: false, hidden: false },
            { key: 'premiacao', label: 'LOJA', route: '/store', disabled: false, hidden: false },
            { key: 'beneficios', label: 'BENEFÍCIOS', route: '/benefits', disabled: false, hidden: false },
            { key: 'multipremios', label: 'MULTIPRÊMIOS', route: '/multi-awards', disabled: false, hidden: false },
            { key: 'desafios', label: 'DESAFIOS', route: '/challenges/list-of-challenges', disabled: false, hidden: false },
            { key: 'multipremios', label: 'MULTISORTE', route: '/multi-awards', disabled: false, hidden: false },
            { key: 'informacao', label: 'INFORMAÇÃO', route: '/information', disabled: false, hidden: false },
            { key: 'faq', label: 'FAQ', route: '/faq', disabled: false, hidden: false },
            { key: 'planos', label: 'PONTUAÇÃO', route: '/plans', disabled: false, hidden: false },
        ];

        setTimeout(async () => {
            this.menuHeader = await this.menuService.disableOrHiddenMenu(this.menuHeader);
        }, 500)

        await this.carregaSaldo();
        await this.carregaPtsExpirar();

        if (!this.modelLocator.dadosLogin.email) {
            this.consultaDados();
        }

    };

    async carregaSaldo() {

        try {

            let config = {
                headers: {
                    "x-token": this.modelLocator.configUso.X_TOKEN_API,
                    "auth-token": this.modelLocator.dadosLogin.hash_auth
                },
                params: {
                    "cpf": this.modelLocator.dadosLogin.cpf
                }
            };

            let url = this.modelLocator.configUso.urlApiPadrao + 'auth/hotsite/v1/extrato/totais';

            this.http.get(url, config).subscribe(
                (data: any) => {
                    if (data['status'] == 200) {
                        this.modelLocator.saldo = data['result'];
                    }
                },
                (err) => {
                    // console.log("Error:", err);

                    if (err['status'] == 401) {
                        alert(err.error.message);
                        this.modelLocator.logado = false;
                        localStorage.clear();
                        this.modelLocator.urlretorno = '';
                        this.router.navigate(['/login']);
                    } else {
                        this.modelLocator.saldo = 0;
                        this.messageServive.showToast('Erro ao processar saldo.', 'warning', 'bottom', 5000, true);
                    }
                }
            );

        } catch (err) {
            this.modelLocator.saldo = 0;
            return this.messageServive.showToast('Erro ao processar saldo.', 'warning', 'bottom', 5000, true);
        }

    };

    carregaPtsExpirar() {

        //console.log('pontos expirar: ');

        try {

            let config = {
                headers: {
                    "x-token": this.modelLocator.configUso.X_TOKEN_API,
                    "auth-token": this.modelLocator.dadosLogin.hash_auth
                },
                params: {
                    "cpf": this.modelLocator.dadosLogin.cpf
                }
            };

            let url = this.modelLocator.configUso.urlApiPadrao + 'auth/hotsite/v1/extrato/expirar';

            this.http.get(url, config)
                .subscribe({


                    next: (data) => {

                        if (data['status'] == 200) {
                            this.modelLocator.pts_expirar = data['pts_expirar'];
                        }

                        //console.log(this.modelLocator.pts_expirar);

                    }, error: (_err) => {
                        // console.log("🚀 ~ file: mm-menu-header.component.ts:126 ~ MmMenuHeaderComponent ~ carregaPtsExpirar ~ err:", err)

                        this.modelLocator.pts_expirar = 0;
                        return this.messageServive.showToast('Erro ao processar pontos a expirar.', 'warning', 'bottom', 5000, true);

                    }
                });

        } catch (_err) {
            this.modelLocator.pts_expirar = 0;
            return this.messageServive.showToast('Erro ao processar pontos a expirar.', 'warning', 'bottom', 5000, true);
        }


        return;
    };

    consultaDados() {

        //console.log('>>>>> consultaDados()');

        try {

            let config = {
                headers: {
                    "x-token": this.modelLocator.configUso.X_TOKEN_API,
                    "auth-token": this.modelLocator.dadosLogin.hash_auth
                },
                params: {
                    "cpf": this.modelLocator.dadosLogin.cpf
                }
            };

            let url = this.modelLocator.configUso.urlApiPadrao + 'auth/hotsite/v1/usuario/consulta';

            this.http.get(url, config)
                .subscribe(data => {

                    if (data['status'] == 200) {

                        this.modelLocator.dadosLogin.email = data['result'].email;
                        this.modelLocator.dadosLogin.celular = data['result'].celular;
                        this.modelLocator.dadosLogin.sexo = data['result'].sexo;
                        this.modelLocator.dadosLogin.nascimento = data['result'].nascimento;

                        localStorage.setItem('AUTH', JSON.stringify(this.modelLocator.dadosLogin));
                        //console.log('>>>>> dadosLogin:' + JSON.stringify(this.modelLocator.dadosLogin));

                    }

                });

        } catch (error) {

        }

    }

    touchGoToRoute(rota: string) {
        this.router.navigate([rota]);
    };

    logout() {

        this.modelLocator.logado = false;
        localStorage.clear();
        this.modelLocator.urlretorno = '';
        this.router.navigate(['/login']);

    };

}
